import api from './client'

export interface Corpus {
  corpus_id: string
  slug: string
  name: string
  description?: string | null
  is_default: boolean
  created_at: string
  article_count: number
}

export const corpusApi = {
  list: () => api.get<Corpus[]>('/corpora'),
  // Admin
  adminList: () => api.get<Corpus[]>('/admin/corpora'),
  create: (data: { name: string; slug?: string; description?: string }) =>
    api.post<Corpus>('/admin/corpora', data),
  update: (corpusId: string, data: { name?: string; description?: string; is_default?: boolean }) =>
    api.patch<Corpus>(`/admin/corpora/${corpusId}`, data),
  delete: (corpusId: string) => api.delete(`/admin/corpora/${corpusId}`),
  // Per-user database access
  setUserCorpora: (userId: string, corpusIds: string[]) =>
    api.put(`/admin/users/${userId}/corpora`, { corpus_ids: corpusIds }),
}
